import React, { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldAlt, // For Metasploit
  faBug, 
  faCube, 
  faTh, 
  faDatabase // For Burp Suite
} from "@fortawesome/free-solid-svg-icons";
import { faLinux } from "@fortawesome/free-brands-svg-icons";

// Define the techStack array with the appropriate icons
const techStack = [
  { name: "Android", iconClass: "devicon-android-plain colored" },
  { name: "React", iconClass: "devicon-react-original colored" },
  { name: "Linux", iconClass: faLinux },
  { name: "Solidity", iconClass: "devicon-solidity-plain colored" },
  { name: "Meta sploit", iconClass: faShieldAlt },
  { name: "PyTorch", iconClass: "devicon-pytorch-original colored" },
  { name: "Git", iconClass: "devicon-git-plain colored" },
  { name: "GitHub", iconClass: "devicon-github-original colored" },
  { name: "NodeJS", iconClass: "devicon-nodejs-plain colored" },
  { name: "Post man", iconClass: "devicon-postman-plain colored" },
  { name: "Burp Suite", iconClass: faBug },
  { name: "Figma", iconClass: "devicon-figma-plain colored" },
  { name: "Blender", iconClass: faCube },
  { name: "NumPy", iconClass: faTh },
  { name: "Pandas", iconClass: faDatabase },
];

// Forward the ref and pass it to the section element
const TechStack = forwardRef((props, ref) => {
  return (
    <section ref={ref} className="py-8 px-4 bg-black lg:m-10">
      <h2 className="text-3xl font-semibold mt-10 mb-10 text-center text-white">
        Techstack
      </h2>

      <ul className="grid grid-cols-3 sm:grid-cols-3 boxShadow lg:m-15 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {techStack.map((tech, index) => (
          <li
            key={index}
            className="flex items-center justify-center p-4 border border-primary-800 rounded-lg shadow-lg bg-transparent text-white transition ease-in-out duration-300 hover:bg-gray-800"
          >
            {typeof tech.iconClass === "string" ? (
              <i className={`${tech.iconClass} text-2xl mr-2`}></i>
            ) : (
              <FontAwesomeIcon icon={tech.iconClass} className="text-2xl mr-2" />
            )}
            <span className="text-center">{tech.name}</span>
          </li>
        ))}
      </ul>
    </section>
  );
});

export default TechStack;
